/**
 * App Entry File
 * Vuely: A Powerfull Material Design Admin Template
 * Copyright 2018. All Rights Reserved
 * Created By: The Iron Network, LLC
 * Made with Love
 */
import 'babel-polyfill'

// API
import Api, { ApiURL } from 'Api'

import App from './App.vue'
// Config
import AppConfig from './constants/AppConfig'
// global components
import GlobalComponents from './globalComponents'
import Notifications from 'vue-notification'
import Nprogress from 'nprogress'
import Vue from 'vue'
import { Vue2Dragula } from 'vue2-dragula'
import VueBreadcrumbs from 'vue2-breadcrumbs'
import VueI18n from 'vue-i18n'
import { VueMasonryPlugin } from 'vue-masonry'
import VueMobileDetection from 'vue-mobile-detection'
import VueResource from 'vue-resource'
import fullscreen from 'vue-fullscreen'
// messages
import messages from './lang'
// Mixin
import mixin from './constants/Mixin.js'
// router
import router from './router'
// store
import { store } from './store/store'
import velocity from 'velocity-animate'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.config.baseurl = 'https://dashboard.spacelearn.net'

Vue.use(VueI18n)
Vue.use(Vue2Dragula)
Vue.use(VueResource)
Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(fullscreen)
Vue.use(GlobalComponents)
Vue.use(VueMasonryPlugin)
Vue.use(VueMobileDetection)

window.Vue = require('vue')

if(  process.env.NODE_ENV !== 'development' ){
    console.log = function(...args){}
    console.warn = function(...args){}
}
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: store.getters.selectedLocale.locale, // set locale
    messages // set locale messages
})

Vue.mixin(mixin)
Vue.use({
    install(Vue) {
        Vue.prototype.$config = AppConfig
    }
})

// navigation guards before each
router.beforeEach((to, from, next) => {
    document.title = i18n.t(to.meta.title) + ' | ' + AppConfig.brand
    Nprogress.start()
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (localStorage.getItem('user') === null) {
            next({
                name: 'login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

// navigation guard after each
router.afterEach(() => {
    Nprogress.done()
    setTimeout(() => {
        const contentWrapper = document.querySelector('.v-content__wrap')
        if (contentWrapper !== null) {
            contentWrapper.scrollTop = 0
        }
        const boxedLayout = document.querySelector('.app-boxed-layout .app-content')
        if (boxedLayout !== null) {
            boxedLayout.scrollTop = 0
        }
        const miniLayout = document.querySelector('.app-mini-layout .app-content')
        if (miniLayout !== null) {
            miniLayout.scrollTop = 0
        }
    }, 200)
})

window.$Api = Api
window.$ApiURL = ApiURL

store
    .dispatch('fetchUser', localStorage.getItem('token'))
    .then(() => {
        setTimeout(function () {
            window.theVue = new Vue({
                store,
                i18n,
                router,
                vuetify,
                render: (h) => h(App),
                components: { App }
            }).$mount('#app')

            theVue.$vuetify.rtl = false
        }, 500)
    })
    .catch((err) => console.log(err))
